import gql from 'graphql-tag'

export const GET_DISHES_PRICES_PAGINATION_QUERY = gql`
  query GetDishesPricesPagination (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
    $query: String
  ) {
    getDishesPrices (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
        query: $query
      }
    ) {
      hasMore
      total
      items {
        id
        title
        prices {
          value
        }
      }
    }
  }
`
